import { useRef } from "react";
import { useTranslation } from "react-i18next";

const PaymentReceipt = ({
  student,
  amount,
  date,
  receiptNumber,
  paymentFor = "School Fees",
  paymentMethod = "cash",
  notes = "",
  kassa,
  academicYear,
  discountInfo,
  receiptRef,
}) => {
  const { t } = useTranslation("general");

  // Format date for display
  const formatDateDisplay = (dateString) => {
    if (!dateString) return "";
    const dateObj = new Date(dateString);
    return dateObj.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };

  const organizationName = localStorage.getItem("organizationName");

  return (
    <div ref={receiptRef} className="o-column printing sp-receipt-container">
      {/* Header - Matching your sample receipt */}
      <div className="sp-header">
        <h1 className="sp-title">{t("paymentReceipt")}</h1>
      </div>

      {/* Company Info and Receipt Number */}
      <div className="sp-company-receipt-info">
        <div>
          <strong>{organizationName}</strong>
        </div>
        <div>
          <strong>
            {t("receiptNumber")}: {receiptNumber || "N/A"}
          </strong>
        </div>
      </div>

      <div className="sp-date-info">
        <div>
          <strong>
            {t("Date")}: {formatDateDisplay(date)}
          </strong>
        </div>
      </div>

      {/* Receipt Details - Matching your sample table structure */}
      <table className="sp-details-table">
        <tbody>
          <tr>
            <td className="sp-table-label">{t("studentName")}:</td>
            <td className="sp-table-value">{student?.fullName || "N/A"}</td>
          </tr>

          {student?.studentCode && (
            <tr>
              <td className="sp-table-label">{t("studentId")}:</td>
              <td className="sp-table-value">{student.studentCode}</td>
            </tr>
          )}
          <tr>
            <td className="sp-table-label">{t("amount")}:</td>
            <td className="sp-table-value">
              <strong>{amount} IQD</strong>
            </td>
          </tr>

          <tr>
            <td className="sp-table-label">{t("paymentMethod")}:</td>
            <td className="sp-table-value">{t("cash")}</td>
          </tr>
          {academicYear && (
            <tr>
              <td className="sp-table-label">{t("academicLevel")}:</td>
              <td className="sp-table-value">{academicYear}</td>
            </tr>
          )}
          {/* {kassa && (
            <tr>
              <td className="sp-table-label">{t("kassa")}:</td>
              <td className="sp-table-value">{kassa}</td>
            </tr>
          )} */}
          {discountInfo && (
            <tr>
              <td className="sp-table-label">{t("discount")}:</td>
              <td className="sp-table-value">{discountInfo}</td>
            </tr>
          )}

          {
            <tr>
              <td className="sp-table-label">{t("notes")}:</td>
              <td className="sp-table-value sp-notes-cell">
                {notes || <span className="t-bold_bold">{t("none")}</span>}
              </td>
            </tr>
          }
        </tbody>
      </table>

      {/* Signature Area */}
      <div className="sp-signature-area">
        <div className="sp-signature-container">
          <div className="sp-signature-field">
            <div className="sp-signature-label">{t("by")}:</div>
            <div className="sp-signature-line"></div>
          </div>
          <div className="sp-signature-field">
            <div className="sp-signature-label">{t("signature")}: </div>
            <div className="sp-signature-line"></div>
          </div>
        </div>
      </div>

      {/* Footer - Matching your sample */}
      <div className="sp-footer">
        <div>
          <p className="sp-footer-main-text">{t("ehsiblySecondSlogan")}</p>
          <p>{t("alhabbarSlogan")}</p>
        </div>
      </div>
    </div>
  );
};

export default PaymentReceipt;
